<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400">
      <template v-slot:activator="{ on }">
        <v-btn
          title="Send password reset link"
          text
          x-small
          v-on="on"
          v-on:click="activateDialog"
          ><icon icon="envelope" color="primary"
        /></v-btn>
      </template>

      <v-card class="mx-auto primary--text">
        <v-card-title>Send Password Reset Link</v-card-title>

        <v-card-text>
          <p>Do you want to send a password recovery link to {{ email }}?</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancel">Cancel</v-btn>
          <v-btn color="primary" text @click="sendEmail">Send Email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    email: function () {
      return this.user.email;
    },
  },
  methods: {
    activateDialog: function () {
      this.$store.commit("usersModule/setUser", this.user);
      this.dialog = true;
    },
    sendEmail: async function () {
      await this.$store.dispatch("usersModule/sendPasswordResetEmail");
      this.dialog = false;
    },
    cancel: function () {
      this.$store.commit("usersModule/clearUser");
      this.dialog = false;
    },
  },
};
</script>
